var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
import ButtonAction from '../../components/utilities/ButtonAction';
var cardStyles = require('src/imports/styles/extend.card.scss');
var selfStyles = require('./styles.scss');
var CardGenerator = (function (_super) {
    __extends(CardGenerator, _super);
    function CardGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardGenerator.prototype.render = function () {
        var _this = this;
        var filterCategory = this.props.filterCategory;
        var filterRound = this.props.filterRound;
        var category = this.props.categories.find(function (c) { return c.id === filterCategory; });
        var round = this.props.rounds.find(function (c) { return c.id === filterRound; });
        var scorecardCount = round
            ? this.props.athleteScores.filter(function (aS) { return aS.roundId === round.id; }).length.toString()
            : '??';
        return (React.createElement(React.Fragment, null,
            React.createElement(Card, null,
                React.createElement("section", { className: selfStyles.formSection },
                    React.createElement("h2", { className: cardStyles.header }, "Step 1: Select a Category"),
                    React.createElement(Select, { size: 'large', className: selfStyles.select, value: this.props.filterCategory, onChange: function (value) {
                            _this.props.setFilters({ filterCategory: value, filterRound: '' });
                        } }, this.props.categories
                        .sort(function (a, b) { return a.name.localeCompare(b.name); })
                        .map(function (c) { return (React.createElement(Select.Option, { key: c.id, value: c.id }, c.name)); }))),
                React.createElement("section", { className: selfStyles.formSection },
                    React.createElement("h2", { className: cardStyles.header }, "Step 2: Select a Round"),
                    React.createElement(Select, { size: 'large', className: selfStyles.select, disabled: !this.props.filterCategory, value: this.props.filterRound, onChange: function (value) {
                            _this.props.setFilters({ filterRound: value });
                        } }, this.props.rounds
                        .filter(function (r) { return filterCategory && r.categoryId === filterCategory; })
                        .sort(function (a, b) { return a.index - b.index; })
                        .map(function (r) { return (React.createElement(Select.Option, { key: r.id, value: r.id },
                        r.name,
                        category ? ", " + category.name : '')); })))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Divider, null),
                    React.createElement(ButtonAction, { isDisabled: !round },
                        React.createElement("button", { onClick: this.props.handleGenerateScorecards },
                            "Generate ",
                            scorecardCount,
                            " scorecards"))))));
    };
    return CardGenerator;
}(React.Component));
export default CardGenerator;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageScorecard/CardGenerator.tsx
// module id = 1322
// module chunks = 0